import React from 'react';
import { FareResponse } from '../../types/fare';
import { Cloud, AlertTriangle, MessageCircle, Calendar } from 'lucide-react';

interface ContextCardsProps {
  fareData: FareResponse;
}

export default function ContextCards({ fareData }: ContextCardsProps) {
  const { weather, hotspot, negotiationTip, context } = fareData;

  return (
    <div className="space-y-3">
      {/* Weather Alert */}
      {weather.note && (
        <div
          className={`rounded-lg p-4 border-l-4 ${
            weather.severity === 'high'
              ? 'bg-red-50 border-red-500'
              : 'bg-blue-50 border-blue-500'
          }`}
        >
          <div className="flex items-start gap-3">
            <Cloud
              size={20}
              className={weather.severity === 'high' ? 'text-red-600' : 'text-blue-600'}
            />
            <div className="flex-1">
              <div
                className={`font-semibold mb-1 ${
                  weather.severity === 'high' ? 'text-red-900' : 'text-blue-900'
                }`}
              >
                Weather Alert
              </div>
              <div
                className={`text-sm ${
                  weather.severity === 'high' ? 'text-red-800' : 'text-blue-800'
                }`}
              >
                {weather.note}
              </div>
              <div
                className={`text-xs mt-1 ${
                  weather.severity === 'high' ? 'text-red-700' : 'text-blue-700'
                }`}
              >
                Ceiling increased by {(weather.appliedMultiplier * 100).toFixed(0)}%
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hotspot Warning */}
      {hotspot && (
        <div className="bg-yellow-50 border-l-4 border-yellow-500 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <AlertTriangle size={20} className="text-yellow-600" />
            <div className="flex-1">
              <div className="font-semibold text-yellow-900 mb-1">Tourist Hotspot</div>
              <div className="text-sm text-yellow-800">{hotspot}</div>
              <div className="text-xs text-yellow-700 mt-1">
                Fares may be 10% higher at tourist locations
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Negotiation Tip */}
      {negotiationTip && (
        <div className="bg-cyan-50 border-l-4 border-cyan-500 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <MessageCircle size={20} className="text-cyan-600" />
            <div className="flex-1">
              <div className="font-semibold text-cyan-900 mb-1">Negotiation Tip</div>
              <div className="text-sm text-cyan-800">{negotiationTip}</div>
            </div>
          </div>
        </div>
      )}

      {/* Context Notes (Holidays) */}
      {context && context.length > 0 && (
        <div className="bg-gray-50 border-l-4 border-gray-400 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Calendar size={20} className="text-gray-600" />
            <div className="flex-1">
              <div className="font-semibold text-gray-900 mb-2">Special Notes</div>
              <ul className="space-y-1">
                {context.map((note, index) => (
                  <li key={index} className="text-sm text-gray-700 flex items-start gap-2">
                    <span className="text-gray-400">•</span>
                    <span>{note}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

